import NavigationService from "./NavigationService";
import EventTypes from "./EventTypes";

const service = new NavigationService();

module.exports = {
  EventTypes,
  NavigationService: service
};



// WEBPACK FOOTER //
// ./packages/foundation-ui/src/navigation/index.js